import { useCallback, } from 'react';
import { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Description from '../UI/Description.jsx';
import Remerciement from '../UI/Remerciement.jsx';
import ImageBackground from '../UI/ImageBackground.jsx'
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import AudioRecorder from '../UI/AudioRecorder.jsx';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Compteur from '../UI/Compteur.jsx';
import TextParticipation from '../UI/TextParticipation.jsx';

function TEX501100({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVideo,
    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setField,
    saveDonneePersonnelle,
    setMessageErreur,
    userInformation,
    retourAccueil,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    donneesPersonnelleValid,
    participation,
    changerAfficherEtapeCollecteParticipationTexte,
    changerAfficherEtapeCollecteParticipationVoix,
    afficherEtapeCollecteParticipationTexte,
    afficherEtapeCollecteParticipationVoix,
    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendingParticipationState,
    changerEtapeCollecteParticipationVocale,
    changerEtapeCollecteParticipationTexte,
}) {
    const {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur,
    } = ManageCompteur(interaction);

    const [asAlreadyVoted, setAsAlreadyVoted] = useState('');
    const [showAlreadyVoted, setShowAlreadyVoted] = useState(false);

    const verifyAsAlreadiVoted = (callback) => {
        if (interaction.limit_1_vote && interaction.asAlreadyVoted) {
            setAsAlreadyVoted('as-already-voted');
            setShowAlreadyVoted(true);
            setTimeout(() => {
                setAsAlreadyVoted('');
                setShowAlreadyVoted(false);
            }, 3000);
            return;
        }
        callback();
    }

    const handleStartRecording = useCallback(
        (status) => {
            if (status === 'start') {
                startCountdownTimer();
            }
            if (status === 'stop') {
                stopCountdownTimer();
                setAfficherCompteur(true);
            }
        },
        [setAfficherCompteur, startCountdownTimer, stopCountdownTimer]
    );

    const [afficherEtapeCollecteParticipationImage, setAfficherEtapeCollecteParticipationImage] = useState(true);

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );


    return (
        <>
            {afficherAccueil && changerAfficherEtapeCollecteParticipation()}
            {afficherEtapeCollecteParticipationVoix &&
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>

                    <div class="fond-gris-widget">
                        <Row className="text-center">
                            <Col>
                                <AudioRecorder
                                    audioURL={audioURL}
                                    setAudioURL={setAudioURL}
                                    audioBlob={audioBlob}
                                    sendingParticipationState={sendingParticipationState}
                                    setMessageErreur={setMessageErreur}
                                    setAudioBlob={setAudioBlob}
                                    maxRecordingTime={interaction.max_recording_time}
                                    onStartRecording={handleStartRecording}
                                    changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                                    setAfficherEtapeCollecteParticipationImage={setAfficherEtapeCollecteParticipationImage}
                                    onRestartRecording={handleAfficherCompteur}
                                />
                            </Col>
                        </Row>
                        {afficherCompteur && audioURL === '' &&
                            <>
                                <Row>
                                    <Col>
                                        <Compteur counter={counter} />
                                    </Col>
                                </Row>
                            </>
                        }
                    </div>

                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
            }
            {
                afficherEtapeCollecteParticipationTexte &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>
                    <div class="fond-gris-widget">
                        <Row className="custom-collecte-participation">
                            <Col>
                                <TextParticipation
                                    participation={participation}
                                    sendingParticipationState={sendingParticipationState}
                                    changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
            }
            {
                afficherEtapeCollecteParticipation &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>
                    {showAlreadyVoted &&
                        <>
                            <div className={asAlreadyVoted}  >Désolé, <br />
                                Vous êtes limité à une <br />
                                participation pour cette <br />
                                événement
                            </div>
                        </>
                    }
                    <Row className="custom-collecte-participation">
                        <Col>
                            <Row className="home-background text-center">
                                <Col>
                                    <ImageBackground interaction={interaction} isImageBlur={true} />
                                </Col>
                            </Row>
                            <div className="bouton-bfm">
                                <Row className="custom-commandes">
                                    <Col>
                                        <Button className="custom-btn-ecrit-main-btn" onClick={e => verifyAsAlreadiVoted(changerAfficherEtapeCollecteParticipationTexte)}>Réagissez en direct</Button>
                                    </Col>
                                </Row>
                                <Row className="custom-commandes">
                                    <Col>&nbsp;
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </>
            }
            {
                afficherEtapeCollectInformationsPersonnelles &&
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>
                    <div class="fond-gris-widget">
                        <DonneesPersonnelles
                            interaction={interaction}
                            setField={setField}
                            userInformation={userInformation}
                            donneesPersonnelleValid={donneesPersonnelleValid}
                            handleRememberMeChange={handleRememberMeChange}
                            rememberMe={rememberMe}
                            canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                            saveDonneePersonnelle={saveDonneePersonnelle}
                        />
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de collecte de données personnelles
            }
            {
                afficherEtapeGRPD &&
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>
                    <div class="fond-gris-widget">
                        <Consent
                            customisation={interaction.segment_customisation}
                            consentGDPR={consentGDPR}
                            consentImage={consentImage}
                            setConsent={setConsent}
                        />
                        <Row className="custom-commandes">
                            <Col>
                                <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled}>Continuer</Button>
                            </Col>
                        </Row>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de consentement
            }
            {
                afficherEtapeRemerciement &&
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>
                    <div class="fond-gris-widget">
                        <Row className="custom-commandes">
                            <Col>
                                <Remerciement interaction={interaction} >Continuer</Remerciement>
                            </Col>
                        </Row>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de remerciemeent
            }
        </>
    )
}
export default TEX501100;
